// template
export const CHANGE_COMPONENT = "CHANGE_COMPONENT";
export const TOGGLE_SIDENAV = "TOGGLE_SIDENAV";
export const SET_AVAIL_CHECKS = "SET_AVAIL_CHECKS";
